export const initialState = {
  user: null,
  token: null,
  // DEBUG value:
  // token:
  //   "BQC4OZZVHoz390tmFQ7FP5kGZ5D2ZoTbmNuCC109vkB-CU-KW0eLo1Aej-WS2_5KJ6aDwjMRIukiWcAQS4xD7Bl2uM4JGSZ0OQNJD-r7SE8JajDsrUsc8s42CKQBYZqBBQI-UIuNskgVu9CEN1g6df3BWgt0OByS3iPiA-_7EZIskqia",
  playlists: [],
  default_playlist: {},
  playing: false,
  item: null,
};

const reducer = (state, action) => {
  console.log("reducer action - ", action);

  switch (action.type) {
    case "SET_USER":
      return { ...state, user: action.user };
    case "SET_TOKEN":
      return { ...state, token: action.token };
    case "SET_PLAYLISTS":
      return { ...state, playlists: action.playlists };
    case "SET_DEFAULT_PLAYLIST":
      return { ...state, default_playlist: action.default_playlist };
    default:
      return state;
  }
};

export default reducer;
